/* ==========================================================================
   prinsert-eco-box.js   -- Fassung 9
   --------------------------------------------------------------------------
   Zum Pruefen, welche Fassung im Browser laeuft, in der Konsole eingeben:
       window.__prinsertEcoBoxVersion

   Setzt das Kontrollkaestchen "Wiederverwendeten Versandkarton verwenden"
   in den Warenkorb -- auf der Seite /cart und in der Schublade.

   ==========================================================================
   ALLE TEXTE KOMMEN AUS snippets/prinsert-shipping-bar.liquid (10.09.2026)

   JavaScript-Dateien werden von Shopify nicht durch Liquid geschickt; der
   t-Filter steht hier also nicht zur Verfuegung. Die Texte liegen als
   data-Attribute an #PrinsertEcoData und stammen von dort aus den
   Sprachdateien.

   VORHER standen sie fest im Code -- im englischen Warenkorb stand deshalb
   "Wiederverwendeten Versandkarton verwenden" direkt neben "Estimated
   total".

   DAS WARENKORB-ATTRIBUT WIRD NICHT UEBERSETZT. Es kommt zwar ebenfalls
   aus dem Datentraeger, ist dort aber fest deutsch hinterlegt: Unter
   diesem Namen landet der Wert in der Bestellung. Eine je nach Sprache
   andere Bezeichnung wuerde in Bestelluebersicht, Packzettel und
   Buchhaltung zu mehreren Feldern fuer dieselbe Sache fuehren.

   RUECKFALLWERTE: Fehlt der Datentraeger, greifen die deutschen Texte
   unten. Sichtbar wird das nur, wenn das Snippet nicht gerendert wurde --
   dann ist deutscher Text besser als gar keiner.

   ==========================================================================
   ZURUECKGEBAUT: DER BEWERTUNGSBLOCK

   Bis Fassung 7 hat dieses Skript den Judge.me-Block aus dem scrollenden
   Bereich in den Fussbereich gezogen, damit er immer sichtbar bleibt.
   Vier Anlaeufe, keiner hat gehalten:

     1. position: sticky mit max-height   Karten verschwanden -- das
                                          Karussell misst sich beim Aufbau
                                          selbst und vertraegt keine
                                          Hoehenvorgabe von aussen
     2. sticky ohne max-height            Block nahm die ganze Schublade
                                          ein und verdeckte die Produkte
     3. Verschieben in den Fussbereich    Bewertungen nicht mehr anklickbar
     4. eigener Container im Fussbereich  ebenso

   Der Block laeuft jetzt wieder dort, wo Judge.me ihn hinsetzt: im
   scrollenden Bereich hinter den Produkten.

   WER ES ERNEUT VERSUCHT: Das Problem ist nicht die Positionierung,
   sondern dass der Block von einer fremden App aufgebaut und verwaltet
   wird. Jeder Eingriff von aussen kollidiert an einer anderen Stelle.

   ==========================================================================
   DAS KAESTCHEN -- FESTGELEGTE PUNKTE

   WARUM NICHT IM CHECKOUT: Felder auf der Checkout-Seite brauchen eine
   Checkout-UI-Erweiterung, und die ist dem Plus-Tarif vorbehalten. Der
   Warenkorb ist auf dem Basic-Tarif die letzte Station.

   WIE DER WERT IN DIE BESTELLUNG KOMMT: Als Warenkorb-Attribut ueber
   /cart/update.js. Ein leerer String loescht das Attribut wieder --
   deshalb wird beim Abwaehlen '' geschrieben und nicht 'Nein'. So stehen
   in den Bestellungen nur die Faelle mit ausdruecklicher Zustimmung.

   BEWUSST OHNE name-ATTRIBUT: Das Kaestchen liegt auf /cart im
   Warenkorb-Formular; ein benanntes Feld wuerde beim Absenden mitgehen
   und mit dem Attribut kollidieren.

   DER HINWEIS KLAPPT IM FLUSS AUF, NICHT ALS SCHWEBENDE BLASE. Drei
   Anlaeufe mit position: absolute beziehungsweise fixed sind an der
   Schublade gescheitert: Sie beschneidet ihren Inhalt (overflow).
   BITTE NICHT WIEDER IN EIN POPUP VERWANDELN.

   DAS i-SYMBOL LIEGT AUSSERHALB DES LABELS. Innerhalb waere jeder Klick
   darauf zugleich ein Klick auf die Beschriftung und wuerde das Kaestchen
   umschalten.

   DER KNOPF IST type="button": Ein <button> ohne Typ ist innerhalb eines
   Formulars ein Absende-Knopf.
   ========================================================================== */

(function () {
  if (window.__prinsertEcoBox) return;
  window.__prinsertEcoBox = true;
  window.__prinsertEcoBoxVersion = 9;

  /* Rueckfallwerte -- siehe Kopf der Datei. */
  var ATTR = 'Wiederverwendeter Karton';
  var YES = 'Ja';
  var LABEL = 'Wiederverwendeten Versandkarton verwenden';
  var INFO =
    'Wenn m\u00f6glich, verwenden wir f\u00fcr deine Bestellung einen bereits ' +
    'verwendeten, noch stabilen Versandkarton. Damit geben wir Verpackungen ' +
    'ein zweites Leben, vermeiden Abfall und tragen dazu bei, wertvolle ' +
    'Ressourcen zu schonen. Der Karton kann leichte Gebrauchsspuren aufweisen.';
  var INFO_ARIA = 'Mehr Informationen zum wiederverwendeten Versandkarton';

  /* Einmal beim Start aus dem Datentraeger lesen. Er wird von
     layout/theme.liquid gerendert und aendert sich waehrend des Besuchs
     nicht -- ein Sprachwechsel laedt die Seite ohnehin neu. */
  (function leseTexte() {
    var el = document.getElementById('PrinsertEcoData');
    if (!el) return;

    ATTR = el.getAttribute('data-attribute') || ATTR;
    YES = el.getAttribute('data-value-yes') || YES;
    LABEL = el.getAttribute('data-label') || LABEL;
    INFO = el.getAttribute('data-info') || INFO;
    INFO_ARIA = el.getAttribute('data-info-aria') || INFO_ARIA;
  })();

  var state = false;
  var scheduled = null;

  function buildBlock() {
    var wrap = document.createElement('div');
    wrap.className = 'prinsert-eco';
    wrap.setAttribute('data-prinsert-eco', '');

    /* Zeile: Kaestchen, Text, Symbol -- drei Spalten, die nicht umbrechen. */
    var row = document.createElement('div');
    row.className = 'prinsert-eco__row';

    var label = document.createElement('label');
    label.className = 'prinsert-eco__label';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'prinsert-eco__checkbox';
    input.checked = state;
    input.addEventListener('change', function () {
      save(input.checked);
    });
    label.appendChild(input);

    var text = document.createElement('span');
    text.className = 'prinsert-eco__text';
    text.textContent = LABEL;
    label.appendChild(text);

    row.appendChild(label);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'prinsert-eco__info-btn';
    btn.setAttribute('aria-label', INFO_ARIA);
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'i';
    row.appendChild(btn);

    wrap.appendChild(row);

    var hint = document.createElement('div');
    hint.className = 'prinsert-eco__hint';
    hint.textContent = INFO;
    hint.hidden = true;
    wrap.appendChild(hint);

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      hint.hidden = !hint.hidden;
      btn.setAttribute('aria-expanded', hint.hidden ? 'false' : 'true');
      btn.classList.toggle('is-open', !hint.hidden);
    });

    return wrap;
  }

  /* ANKERPUNKTE -- die Notiz sieht auf /cart und in der Schublade
     unterschiedlich aus:

       /cart      <cart-note class="cart__note field"> ... </cart-note>
       Schublade  <details> <summary>Spezielle Bestellanweisungen</summary>
                    <cart-note> ... </cart-note>
                  </details>

     Deshalb wird ZUERST auf ein umgebendes <details> geprueft. Ohne das
     landete das Kaestchen INNERHALB des Aufklappbereichs: zugeklappt gar
     nicht sichtbar, aufgeklappt hinter dem Textfeld. */
  function anchors() {
    var found = [];

    document.querySelectorAll('textarea[name="note"]').forEach(function (note) {
      var host =
        note.closest('details') ||
        note.closest('.cart__note') ||
        note.closest('cart-note') ||
        note.parentElement;
      if (host) found.push({ host: host, position: 'afterend' });
    });

    if (!found.length) {
      document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
        var host = btn.closest('.cart__ctas') || btn.parentElement;
        if (host) found.push({ host: host, position: 'beforebegin' });
      });
    }

    return found;
  }

  function alreadyThere(host, position) {
    var sibling = position === 'afterend' ? host.nextElementSibling : host.previousElementSibling;
    return !!(sibling && sibling.hasAttribute && sibling.hasAttribute('data-prinsert-eco'));
  }

  function sync() {
    document.querySelectorAll('.prinsert-eco__checkbox').forEach(function (box) {
      if (box.checked !== state) box.checked = state;
    });
  }

  function render() {
    anchors().forEach(function (entry) {
      if (alreadyThere(entry.host, entry.position)) return;
      entry.host.insertAdjacentElement(entry.position, buildBlock());
    });
    sync();
  }

  function save(value) {
    state = value;
    sync();

    var body = { attributes: {} };
    body.attributes[ATTR] = value ? YES : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {
      /* Netzwerkfehler: Die Anzeige bleibt stehen, damit der Kunde nicht
         vor einem zurueckspringenden Haken sitzt. */
    });
  }

  function load() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        state = !!(cart && cart.attributes && cart.attributes[ATTR]);
        sync();
      })
      .catch(function () {});
  }

  function start() {
    render();
    load();

    /* Dawn ersetzt den Inhalt der Schublade nach jeder Warenkorb-Aenderung
       komplett -- das Kaestchen muss danach erneut eingesetzt werden. */
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = window.requestAnimationFrame(function () {
        scheduled = null;
        render();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
